export const DISPLAY_WIDTH = '630px';
